<template>
	<div id="ct-realisations">
		<div class="ct-realisations-filtre">
			<p class="ct-realisations-filtre-item">
				<label class="ct-checkbox">
					<input type="checkbox" v-model="filter.f1"/>
					<span>Maçonnerie | Dallage BA</span>
				</label>
			</p>
			<p class="ct-realisations-filtre-item">
				<label class="ct-checkbox">
					<input type="checkbox" v-model="filter.f2"/>
					<span>Portail</span>
				</label>
			</p>
			<p class="ct-realisations-filtre-item">
				<label class="ct-checkbox">
					<input type="checkbox" v-model="filter.f3"/>
					<span>Aménagement extérieur</span>
				</label>
			</p>
		</div>

        <div class="">            
            <h3 v-if="!filteredRealisations.length">Il n'y a aucun projet correspondant à vos filtres.</h3>
        </div>

		<div class="ct-realisations-cards ct-resolution-width">
			<div class="ct-realisations-cards-card" v-for="element in filteredRealisations" :key="element.id">
				<ct-card-realisations :realisation="element" :filter="filter"></ct-card-realisations>
			</div>
		</div>
	</div>
</template>

<script>
	import { getRealisations } from "../actions/realisationsData";
	import _ from 'lodash';

	export default {
		name: 'CtRealisations',
		data() {
			return {
				msg: 'Realisations',
				realisations: [],
				filter: {},
			}
		},
		computed: {
			filteredRealisations: function () {
				return _(this.realisations)
					.filter(real => {
						return (this.filter.f1 &&_.includes(real.types, '1'))
							|| (this.filter.f2 && _.includes(real.types, '2'))
							|| (this.filter.f3 && _.includes(real.types, '3'))
					})
					.value();
			}
		},
		methods: {
			initFilter() {
				//filter params prioritaire
				let params = this.$route.query.filter;
				if(params) {
					return {
						f1: params==='1' || _.includes(params, '1'),
						f2: params==='2' || _.includes(params, '2'),
						f3: params==='3' || _.includes(params, '3'),
					}
				}

				//sinon localStorage
				const localStore = window.localStorage.getItem('FILTER_REALISATIONS');
				if(localStore) {
					return JSON.parse(localStore);
				}

				//sinon tout
				return {
					f1: true,
					f2: true,
					f3: true
				}
			}
		},
		mounted: function() {
			this.filter = this.initFilter();
			this.realisations = getRealisations();
		},
		watch: {
			filter: {
				handler: function() {
					window.localStorage.setItem('FILTER_REALISATIONS', JSON.stringify(this.filter))
				},
				deep: true
			}
		}
	}
</script>
<style>

	[type="checkbox"]:checked+span:not(.lever):before {
		border-right: 2px solid #B0E900;
		border-bottom: 2px solid #B0E900;
	}

	#ct-realisations {
		display: flex;
		justify-content: center;
		flex-direction: column;
		flex-wrap: wrap;
		padding-bottom: 50px;

	}

	.ct-realisations-filtre {
		display: flex;
		justify-content: center;
		margin: auto;
	}

	.ct-realisations-filtre-item {
		padding: 10px;
	}

	.ct-realisations-cards {
		margin: 50px 0 50px 0;
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		flex-direction: row;
		margin: auto;
	}

	.ct-realisations-cards-card {
		width: 30%;
		margin: 15px 0 15px 0;
		min-width: 300px;
	}

	.ct-checkbox {
		display: flex;
	}

	/*!*tablette*!*/
	@media screen and (max-width: 1170px ) {

		.ct-realisations-cards {
			justify-content: space-around;
		}

		.ct-realisations-cards-card {
			width: 40%;
		}
	}

	/*!*smartphone*!*/
	@media screen and (max-width: 767px ) {
		.ct-realisations-filtre {
			flex-direction: column;
			width: 70%;
		}

		.ct-realisations-cards {
			justify-content: center;
		}

		.ct-realisations-cards-card {
			width: 80%;
			min-width: 50%;
		}

	}
</style>



// WEBPACK FOOTER //
// src/components/CtRealisations.vue